<template>
  <div class="heading">
    <div class="headerCopy">
      <div class="quoteBox"></div>
      <h1 class="quoteText">
        We're making this available free, open-source and with no strings attached. We want to help companies thrive in a remote-enabled work environment.
      </h1>
      <div class="subTitleWrapper">
        <div class="line"></div>
      </div>
      <div class="quoteSource">Jason Cottrell, CEO</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  },
  methods: {
    openGitHub() {
      window.open('https://github.com/myplanet/askaway', '_blank')
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.heading {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
}
h1 {
  font-size: 60px;
  color: black;
  line-height: 80px;
}

.heading .littletitle {
  font-size: 15px;
  text-align: left;
  margin-bottom: 20px;
  color: #e1e0e6;
}

.highlight {
  color: #f25930;
}
.subTitleWrapper {
  display: flex;
  align-items: center;
}
.lineCopy {
  width: 145px;
  color: #9292a8;
  font-size: 24px;
  line-height: 23px;
  margin-left: 20px;
}

.subTitleWrapper .line {
  border-top: 2px solid #9292a8;
  width: 90px;
}

.quoteSource {
  color: #9292a8;
  font-size: 14px;
  margin-top: 20px;
  font-family: "SofiaProBold";
}

.quoteBox {
  margin-top: 20px;
  margin-bottom: 20px;
  height: 36px;
  background: url("../assets/quote-mark@2x.png") no-repeat 0px 0px;
  background-size: 36px 32px;
}

.quoteText {
  margin-top: 0px;
}

.headerCopy {
  width: 60%;
  margin: 0 auto;
  text-align: left;
}

h1 {
  color: #9292a8;
  font-family: 'LoraRegular', serif;
  font-size: 39px;
  line-height: 52px;
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .headerCopy {
    width: 60%;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1029px) {
  .headerCopy {
    width: 80%;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .headerCopy {
    width: 80%;
  }

  .heading {
    width: 600px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .headerCopy {
    width: 90%;
  }

  h1 {
    font-size: 30px;
    line-height: 40px;
  }

  .heading {
    width: 100%;
  }
}

@font-face {
  font-family: LoraRegular;
  src: url(../fonts/LoraRegular.ttf) format("truetype");
  font-weight: 400;
  font-style: normal
}
</style>
